import { getWindowObject } from '@utils/documentWindow';

// Only use directly if screen that uses does not rendered
// in server, because server html and hydrate html will defer.
// Instead use useCssTransforms3dSupported hook.
function cssTransforms3d() {
  const windowObj = getWindowObject();
  return windowObj?.Modernizr?.csstransforms3d;
}

export default cssTransforms3d;
